/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_DescriptionInputs */

const en_service_health_nav_description = /** @type {(inputs: Service_Health_Nav_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find reliable and verified health information and learn how to navigate the Canadian healthcare system all in one platform.`)
};

const fr_service_health_nav_description = /** @type {(inputs: Service_Health_Nav_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez des informations de santé fiables et vérifiées et apprenez à naviguer dans le système de santé canadien, le tout sur une seule plateforme.`)
};

/**
* | output |
* | --- |
* | "Find reliable and verified health information and learn how to navigate the Canadian healthcare system all in one platform." |
*
* @param {Service_Health_Nav_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_description = /** @type {((inputs?: Service_Health_Nav_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_description(inputs)
	return fr_service_health_nav_description(inputs)
});